import { v4 as uuidv4 } from 'uuid';
import { IXKeys } from '@/entities/types/interfaces/backend/auth';

export const getHeadersXKeys = (): IXKeys => {
  return {
    'X-Fingerprint': uuidv4(), // сделано через жопу, надо юзать что-то вроде https://github.com/fingerprintjs/fingerprintjs/blob/master/docs/api.md
    'X-Idempotency-key': uuidv4(),
  };
};
